export default "__VITE_ASSET__C_372Em9__";